export default __webpack_public_path__ + "static/media/Squre2.c6d4018d.svg";